
  // prefer default export if available
  const preferDefault = m => (m && m.default) || m
  

exports.ssrComponents = {
  "component---cache-dev-404-page-js": preferDefault(require("/var/www/wasif.dev.jt.hostingshouse.com/public_html/projects/gatsby/mumara1/.cache/dev-404-page.js")),
  "component---src-pages-404-js": preferDefault(require("/var/www/wasif.dev.jt.hostingshouse.com/public_html/projects/gatsby/mumara1/src/pages/404.js"))
  }

